import { Navigate } from "react-router";
import { errorNotification } from "./Notification";
import { useAppSelector } from "../utils/hooks";
import { State } from "../utils/store";

const defaultErrorMessage = "You don't have access to this page";

export const NoAccess = ({
  errorMessage,
}: {
  errorMessage?: string | null;
}) => {
  const notificationErrorMessage = errorMessage || defaultErrorMessage;
  const { selectedClient } = useAppSelector((state: State) => state.clients);

  errorNotification(notificationErrorMessage);

  return <Navigate to={`/${selectedClient?.slug}/dashboard`} replace />;
};
